import ReminderInputMail from '@views/reminder/ReminderInputMail.vue'
import ReminderInputAuth from '@views/reminder/ReminderInputAuth.vue'
import ReminderAccountInputMail from '@views/reminder/ReminderAccountInputMail.vue'
import ReminderEdit from '@views/reminder/ReminderEdit.vue'
import ReminderComplete from '@views/reminder/ReminderComplete.vue'
export default [
  {
    path: '/user/reminder',
    name: 'ReminderInputMail',
    component: ReminderInputMail,
    props: (route) => ({
      useCase: route.query.use_case
    }),
    meta: {
      nav: 'back',
      title: 'メールアドレス認証',
      gaTitle: 'メールアドレス認証',
      footer: true
    }
  },
  {
    path: '/user/reminder/auth',
    name: 'ReminderInputAuth',
    component: ReminderInputAuth,
    // props: (route) => ({
    //   codeRequestId: route.params.codeRequestId,
    //   email: route.query.email,
    //   useCase: route.query.use_case
    // }),
    meta: {
      nav: 'back',
      title: 'ご本人確認のお願い',
      gaTitle: 'ご本人確認のお願い',
      footer: true
    }
  },
  {
    path: '/user/reminderAccount',
    name: 'ReminderAccountInputMail',
    component: ReminderAccountInputMail,
    meta: {
      nav: 'back',
      title: 'アカウント確認',
      gaTitle: 'アカウント確認',
      footer: true
    }
  },
  {
    path: '/user/reminder/edit',
    name: 'ReminderEdit',
    component: ReminderEdit,
    meta: {
      nav: 'back',
      title: 'パスワード変更',
      gaTitle: 'パスワード変更',
      footer: true
    }
  },
  {
    path: '/user/reminder/edit/complete',
    name: 'ReminderComplete',
    component: ReminderComplete,
    meta: {
      nav: 'none',
      title: 'パスワード変更',
      gaTitle: 'パスワード変更',
      footer: true
    }
  }
]
